import { cs } from '../../lib/currency';
import React from 'react';

/**
 * SurchargeAmount — renders a paid amount with CC-surcharge breakdown.
 *
 * Backend (iter239) surfaces base_amount + surcharge_amount + surcharge_percent
 * on Recent Payments / Transactions rows whenever a CC surcharge was added.
 * This component shows the gross total in bold and the breakdown
 * "($165.00 + $4.95 fee)" inline so the cause of the delta from the invoice
 * total is visible at a glance.
 *
 * If no surcharge is present, falls back to a plain `${amount}` render so
 * cash / ACH / credit-funded rows look identical to before.
 */
export default function SurchargeAmount({
  amount,
  baseAmount,
  surchargeAmount,
  surchargePercent,
  className = '',
  testId,
}) {
  const total = Number(amount || 0);
  const sc = Number(surchargeAmount || 0);
  const base = Number(baseAmount || 0);

  if (!Number.isFinite(sc) || sc <= 0.005) {
    return (
      <span className={className} data-testid={testId}>
        {`${cs()}${total.toFixed(2)}`}
      </span>
    );
  }

  return (
    <span className={className} data-testid={testId}>
      <span className="font-semibold">{`${cs()}${total.toFixed(2)}`}</span>
      <span
        className="ml-1 text-[11px] font-normal text-amber-600"
        title="Includes credit-card surcharge"
        data-testid={testId ? `${testId}-breakdown` : undefined}
      >
        {`(${cs()}${base.toFixed(2)} + ${cs()}${sc.toFixed(2)}${
          surchargePercent ? ` · ${Number(surchargePercent).toFixed(1)}%` : ''
        } fee)`}
      </span>
    </span>
  );
}
